(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-slider"] && !Shopify.designMode) return;
  try {
    
  class CustomImageSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-slider-viewport]');
      this.track = this.querySelector('[data-slider-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'));
      this.prevButton = this.querySelector('[data-slider-prev]');
      this.nextButton = this.querySelector('[data-slider-next]');

      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.loopDuration = parseFloat(this.dataset.speed) || 20;
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';

      this.offset = 0;
      this.paused = false;
      this.rafId = null;
      this.lastTimestamp = null;
      this.singleSetWidth = 0;

      if (!this.track || this.slides.length === 0) return;

      this.initSlider();

      this.handleResize = () => this.calculateWidth();
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      window.removeEventListener('resize', this.handleResize);
    }

    initSlider() {
      const clonesNeeded = 2;
      for (let i = 0; i < clonesNeeded; i++) {
        this.slides.forEach((slide) => {
          const clone = slide.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.add('is-clone');
          clone.removeAttribute('data-slider-slide');
          this.track.appendChild(clone);
        });
      }

      this.calculateWidth();

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.stepBy(-1));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.stepBy(1));
      }

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => (this.paused = true));
        this.addEventListener('mouseleave', () => (this.paused = false));
        this.addEventListener('focusin', () => (this.paused = true));
        this.addEventListener('focusout', () => (this.paused = false));
      }
      // Mouse drag
      this.isDragging = false;
      this.didDrag = false;
      this.dragStartX = 0;
      this.dragStartOffset = 0;
      this.dragVelocity = 0;
      this.lastDragX = 0;
      this.lastDragTime = 0;

      this.viewport.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        this.isDragging = true;
        this.didDrag = false;
        this.dragStartX = e.clientX;
        this.dragStartOffset = this.offset;
        this.dragVelocity = 0;
        this.lastDragX = e.clientX;
        this.lastDragTime = performance.now();
        this.paused = true;
        e.preventDefault();
      });

      window.addEventListener('mousemove', (e) => {
        if (!this.isDragging) return;
        const now = performance.now();
        const dx = e.clientX - this.lastDragX;
        const dt = now - this.lastDragTime || 1;
        this.dragVelocity = -dx / (dt / 1000);
        this.lastDragX = e.clientX;
        this.lastDragTime = now;
        const moved = this.dragStartX - e.clientX;
        if (Math.abs(moved) > 5) this.didDrag = true;
        this.offset =
          (((this.dragStartOffset + moved) % this.singleSetWidth) + this.singleSetWidth) % this.singleSetWidth;
        this.track.style.transform = `translate3d(${-this.offset}px, 0, 0)`;
      });

      const endDrag = () => {
        if (!this.isDragging) return;
        this.isDragging = false;
        if (!this.pauseOnHover) this.paused = false;
        // momentum flick
        const momentum = this.dragVelocity * 0.2;
        this.offset = (((this.offset + momentum) % this.singleSetWidth) + this.singleSetWidth) % this.singleSetWidth;
      };

      window.addEventListener('mouseup', endDrag);
      window.addEventListener('mouseleave', endDrag);

      // Click block karo agar drag hua ho
      this.viewport.addEventListener('click', (e) => {
        if (this.didDrag) {
          e.preventDefault();
          e.stopPropagation();
          this.didDrag = false;
        }
      });

      // Touch drag (mobile)
      this.viewport.addEventListener(
        'touchstart',
        (e) => {
          this.isDragging = true;
          this.didDrag = false;
          this.dragStartX = e.touches[0].clientX;
          this.dragStartOffset = this.offset;
          this.dragVelocity = 0;
          this.lastDragX = this.dragStartX;
          this.lastDragTime = performance.now();
          this.paused = true;
        },
        { passive: true }
      );

      this.viewport.addEventListener(
        'touchmove',
        (e) => {
          if (!this.isDragging) return;
          const now = performance.now();
          const cx = e.touches[0].clientX;
          this.dragVelocity = -(cx - this.lastDragX) / ((now - this.lastDragTime || 1) / 1000);
          this.lastDragX = cx;
          this.lastDragTime = now;
          const moved = this.dragStartX - cx;
          if (Math.abs(moved) > 5) this.didDrag = true;
          this.offset =
            (((this.dragStartOffset + moved) % this.singleSetWidth) + this.singleSetWidth) % this.singleSetWidth;
          this.track.style.transform = `translate3d(${-this.offset}px, 0, 0)`;
        },
        { passive: true }
      );

      this.viewport.addEventListener('touchend', endDrag);

      if (this.autoplayEnabled) {
        this.startLoop();
      }
    }

    calculateWidth() {
      const style = window.getComputedStyle(this.track);
      const gap = parseFloat(style.gap) || 0;

      this.singleSetWidth = this.slides.reduce((total, slide) => {
        return total + slide.offsetWidth + gap;
      }, 0);
    }

    stepBy(direction) {
      if (!this.singleSetWidth) return;
      const style = window.getComputedStyle(this.track);
      const gap = parseFloat(style.gap) || 0;
      const stepWidth = this.slides[0].offsetWidth + gap;

      this.offset += stepWidth * direction;

      if (this.offset < 0) this.offset += this.singleSetWidth;
      if (this.offset >= this.singleSetWidth) this.offset -= this.singleSetWidth;

      this.track.style.transition = 'transform 0.5s ease';

      this.track.style.transform = `translate3d(${-this.offset}px, 0, 0)`;

      setTimeout(() => {
        this.track.style.transition = '';
      }, 500);
    }

    startLoop() {
      const tick = (timestamp) => {
        if (!this.lastTimestamp) this.lastTimestamp = timestamp;
        const delta = (timestamp - this.lastTimestamp) / 1000;
        this.lastTimestamp = timestamp;

        if (!this.paused && this.singleSetWidth > 0 && !this.track.style.transition) {
          // ← YE CHECK ADD KARO
          const pxPerSecond = this.singleSetWidth / this.loopDuration;
          this.offset += pxPerSecond * delta;
          if (this.offset >= this.singleSetWidth) {
            this.offset -= this.singleSetWidth;
          }
          this.track.style.transform = `translate3d(${-this.offset}px, 0, 0)`;
        }

        this.rafId = requestAnimationFrame(tick);
      };

      this.rafId = requestAnimationFrame(tick);
    }
  }

  if (!customElements.get('custom-image-slider')) {
    customElements.define('custom-image-slider', CustomImageSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
